export const navigationItems = ['home', 'about', 'services', 'values', 'contact'];
